import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setIsRemoveVirtualBackgroundUploadImage,
    setSelectedVirtualBackgroundImageId,
    setVirtualBackgroundImages,
    setVirtualBackgroundLocalImageUrl,
} from "../../reducers/call-setting-reducer";
import { LOCAL_STORAGE_KEYS } from "../../constants/Constants";
import storage from "../../services/storage";
import CenterModal from "../UI/Modal/CenterModal";
import { VIRTUAL_BACKGROUND } from "../../constants/VirtualBackgroundConstant";
import useLanguageChange from "../../hooks/useLanguageChange";

const RemoveVirtualBackgroundUploadImageModal = () => {
    const dispatch = useDispatch();

    const { virtualBackgroundImages, isRemoveVirtualBackgroundUploadImage, selectedVirtualBackgroundImageId } = useSelector(
        (state) => state.callSetting
    );

    const localisedValues = useLanguageChange();

    const removeVirtualBackgroundUploadImageModal = () => {
        dispatch(setIsRemoveVirtualBackgroundUploadImage(false));
    };

    const removeVirtualBackgroundUploadImage = () => {
        const updatedVirtualbackgroundImages = virtualBackgroundImages.filter((img) => img.id !== VIRTUAL_BACKGROUND.LOCAL_IMAGE_ID);
        dispatch(setVirtualBackgroundImages(updatedVirtualbackgroundImages));
        dispatch(setVirtualBackgroundLocalImageUrl(null));
        storage.set(LOCAL_STORAGE_KEYS.VIRTUAL_BACKGROUND_UPLOAD_IMAGE, null); // set the image in local storage
        if (selectedVirtualBackgroundImageId === VIRTUAL_BACKGROUND.LOCAL_IMAGE_ID) {
            storage.set(LOCAL_STORAGE_KEYS.SELECTED_VIRTUAL_BACKGROUND_IMAGE_ID, VIRTUAL_BACKGROUND.NONE_EFFECT_ID); // set the selected image id in local storage
            dispatch(setSelectedVirtualBackgroundImageId(VIRTUAL_BACKGROUND.NONE_EFFECT_ID));
        }
        removeVirtualBackgroundUploadImageModal();
    };

    const removeVirtualBackgroundUploadImageModalHeader = useMemo(() => {
        return (
            <>
                <h5 className='modal-title'>{localisedValues?.remove_background_image}</h5>
                <button type='button' className='btn-close' aria-label='Close' onClick={removeVirtualBackgroundUploadImageModal}>
                    <span className='btn-icon icon-close-light'></span>
                </button>
            </>
        );
    }, [isRemoveVirtualBackgroundUploadImage]);

    const removeVirtualBackgroundUploadImageModalBody = useMemo(() => {
        return (
            <div className='cms-modal-text'>
                <p>{localisedValues?.are_you_sure_you_want_to_remove_background_image}</p>
            </div>
        );
    }, [isRemoveVirtualBackgroundUploadImage]);

    const removeVirtualBackgroundUploadImageModalFooter = useMemo(() => {
        return (
            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
                <div className='button'>
                    <button className='btn default-btn-link' onClick={removeVirtualBackgroundUploadImageModal}>
                        {localisedValues?.cancel}
                    </button>
                </div>
                <div className='button'>
                    <button className='btn default-btn-primary' onClick={removeVirtualBackgroundUploadImage}>
                        {localisedValues?.remove}
                    </button>
                </div>
            </div>
        );
    }, [isRemoveVirtualBackgroundUploadImage]);

    return (
        <CenterModal
            showModal={isRemoveVirtualBackgroundUploadImage}
            closeModal={() => removeVirtualBackgroundUploadImageModal()}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={removeVirtualBackgroundUploadImageModalHeader}
            body={removeVirtualBackgroundUploadImageModalBody}
            footer={removeVirtualBackgroundUploadImageModalFooter}
            backdrop={"static"}
        />
    );
};

export default RemoveVirtualBackgroundUploadImageModal;
